import { store } from '@/common/root';

const fetchTargetGroupNameAndObsoleteProperty = async (targetGroupId: ID): Promise<{ name: string, is_obsolete: boolean }> => {
  const targetGroup = await store.$takeFirst('iscsi/targetGroups/GET_OR_LOAD', { id: targetGroupId });
  return {
    name: targetGroup.name,
    is_obsolete: targetGroup.is_obsolete
  };
};

export default fetchTargetGroupNameAndObsoleteProperty;
